// src/PingCheck.ts
// Ping de conectividad alineado con la subruta /go-planilla/api
// - Soporta pasar apiBase desde main.ts (recomendado)
// - Fallbacks: VITE_API_BASE_URL/VITE_BACKEND_URL, window.__CONFIG__, y por defecto '/go-planilla/api'

const app = document.querySelector<HTMLDivElement>('#app')!

function stripTrailingSlash(s: string) { return s.replace(/\/+$/, '') }

function resolveApiBase(explicit?: string) {
  if (explicit) return stripTrailingSlash(explicit)

  const envBase =
    (import.meta as any)?.env?.VITE_API_BASE_URL ||
    (import.meta as any)?.env?.VITE_BACKEND_URL || ''

  if (envBase) return `${stripTrailingSlash(String(envBase))}/api`

  const cfg: any = (window as any).__CONFIG__ || {}
  if (cfg.API_BASE) return stripTrailingSlash(String(cfg.API_BASE))
  if (cfg.BACKEND_URL) return `${stripTrailingSlash(String(cfg.BACKEND_URL))}/api`

  // Producción por defecto detrás de Nginx
  return '/go-planilla/api'
}

function renderPingCheck(mensaje: string, color = 'black', onRetry?: () => void) {
  app.innerHTML = `
    <div style="text-align: center; padding: 40px;">
      <p style="color: ${color}; font-weight: bold;">${mensaje}</p>
      <button id="retry" style="margin-top: 20px; padding: 8px 16px;">Reintentar</button>
    </div>
  `
  document.getElementById('retry')?.addEventListener('click', () => onRetry?.())
}

export async function verificarConexion(apiBase?: string) {
  const base = resolveApiBase(apiBase)
  const url = `${base}/comprobantes/_health` // ej: /go-planilla/api/comprobantes/_health

  renderPingCheck('🔄 Conectando con el servidor...', 'gray', () => verificarConexion(base))
  try {
    const res = await fetch(url, { cache: 'no-store' })
    if (!res.ok) {
      const txt = await res.text()
      throw new Error(txt || `HTTP ${res.status}`)
    }
    const text = await res.text()
    // Si responde JSON, intenta parsear (opcional)
    try {
      const json = text ? JSON.parse(text) : null
      console.debug('Health OK:', json)
    } catch {
      console.debug('Health OK (texto):', text)
    }

    localStorage.setItem('conectado', 'true')
    // Deja que main.ts (hash router) maneje la navegación
    if (!location.hash) location.hash = 'login'
    app.innerHTML = '' // limpia pantalla de ping
  } catch (err: any) {
    localStorage.setItem('conectado', 'false')
    renderPingCheck(`❌ No se pudo conectar al backend: ${err?.message || err}`,'red', () => verificarConexion(base))
  }
}
